import { useEffect, useRef, useState } from "react";
import { QuestionCard, Header, Footer } from "./index";
import "./TestScreen.css";
import SectionTabs from "./SectionTabs";
import useAppHooks from "../../../../shared/hooks/useAppHooks";


import {
  saveAnswerRequest,
  submitExamRequest,
  updateQuestionStatus,
  fetchExamQuestionsListRequest,
  setPaperId,
  setActiveSection,
  fetchExamQuestionRequest,
  setCurrentQuestionIndex,
  resetPracticeStreak,
  setPracticeStreak,
  setHideStreakMessage
} from "../../../../redux/exam/examSlice";
import { useLocation } from "react-router-dom";
import SubmitModal from "../../../../shared/components/SubmitModal/SubmitModal";
import images from "../../../../utilities/images/images";
import { getQuestionStats } from "../utils/questionStats";
import { ClipLoader } from "react-spinners";
import { useSelector } from "react-redux";
import PracticeModeProgressBar from "./PracticeModeProgressBar/PracticeModeProgressBar";

//  NEW PRACTICE MODE PROGRESS BAR
// import PracticeModeProgressBar from "../../../../containers/logged_user_components/user_exercise_test/practice_mode_progress_bar/PracticeModeProgressBar";

const TestScreen = () => {
  const { dispatch, history } = useAppHooks();
  const location = useLocation();
  const {
    questionsData,
    currentQuestionIndex,
    loading,
    testDetails,
    plannerDetails,
    paperId,
    selectedSetId,
    timeLeft,
    paper_duration,
    practiceStreak,
    setLastActionType

  } = useSelector((state) => state.examSlice);



  const stats = getQuestionStats(questionsData);


  const [activeQuestionId, setActiveQuestionId] = useState(null);
  const [isSubmitModalOpen, setSubmitModalOpen] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);

  const saveNextClicked = useRef(false);

  const isPracticeMode = testDetails?.practiceMode === "practice";

  /* ======================= LOAD QUESTION LIST ======================= */
  // useEffect(() => {
  //   if (!paperId && testDetails?.paperId) {
  //     dispatch(setPaperId(testDetails?.paperId));
  //   }

  //   if (testDetails?.paperId) {
  //     dispatch(setCurrentQuestionIndex(0));

  //     dispatch(
  //       fetchExamQuestionsListRequest({
  //         paperId: testDetails.paperId,
  //         paperType: plannerDetails?.id,
  //         testId: testDetails?.testId,
  //         setId: selectedSetId,
  //       })
  //     );
  //   }
  // }, [dispatch, testDetails?.paperId]);
  useEffect(() => {
    const navState = location.state || {};

    const finalPaperId =
      testDetails?.paperId ?? navState?.paperId ?? null;

    const finalSetId =
      testDetails?.setId ?? navState?.setId ?? null;

    const finalTestId =
      testDetails?.testId ?? navState?.testId ?? null;

    const finalPaperType =
      testDetails?.paperType ?? navState?.paperType ?? plannerDetails?.id;

    if (!finalPaperId && !finalSetId) return;

    dispatch(setCurrentQuestionIndex(0));

    dispatch(
      fetchExamQuestionsListRequest({
        paperId: finalPaperId,
        paperType: finalPaperType,
        testId: finalTestId,
        setId: finalSetId,
      })
    );

    // ✅ run only when test identity changes
  }, [
    dispatch,
    testDetails?.paperId,
    testDetails?.setId,
    testDetails?.testId,
    plannerDetails?.id,
  ]);

  /* ======================= ACTIVE QUESTION ======================= */
  useEffect(() => {
    if (
      questionsData &&
      questionsData[currentQuestionIndex] &&
      questionsData[currentQuestionIndex].qid
    ) {
      setActiveQuestionId(questionsData[currentQuestionIndex].qid);
    }
  }, [questionsData, currentQuestionIndex]);

  /* ======================= SAVE & NEXT ======================= */
  // const handleSaveAndNext = (e) => {
  //   e.preventDefault();


  //   saveNextClicked.current = true;

  //   const currentQuestion = questionsData[currentQuestionIndex];
  //   if (!currentQuestion) return;
  //   const answerType = Number(currentQuestion.answer_type_id);

  //   dispatch(setLastActionType("SAVE_NEXT"));



  //   // 🔥 Remove streak message immediately
  //   dispatch(setPracticeStreak(null));




  //   dispatch(
  //     saveAnswerRequest({
  //       qid: currentQuestion.qid,
  //       paper_id: currentQuestion.paper_id ?? null,
  //       paper_type: testDetails?.paperType,
  //       test_id: testDetails?.testId ?? null,
  //       set_id: selectedSetId ?? null,
  //       time: currentQuestion?.time_taken ?? 0,
  //       option_id:
  //         answerType === 1 || answerType === 2
  //           ? currentQuestion?.selectedOption ?? ""
  //           : "",

  //       option_int:
  //         answerType === 3
  //           ? currentQuestion?.integer_Answer ?? ""
  //           : "",

  //       moveNext: true,  // 🔥 move next question
  //       hideStreakMessage: true
  //     })
  //   );


  // };

  const handleSaveAndNext = (e) => {
    e.preventDefault();

    saveNextClicked.current = true;

    const currentQuestion = questionsData[currentQuestionIndex];
    if (!currentQuestion) return;

    dispatch(setLastActionType("SAVE_NEXT"));

    // 🔥 Remove only the progressive message but keep streak progress
    dispatch(
      setPracticeStreak((prev) => ({
        ...prev,
        progressive_message: null
      }))
    );

    // move next question
    const nextIndex = currentQuestionIndex + 1;

    if (nextIndex < questionsData.length) {
      dispatch(setCurrentQuestionIndex(nextIndex));
    }
  };

  const handleSelectQuestion = (qid) => {
    setActiveQuestionId(qid);

    dispatch(
      updateQuestionStatus({
        qid,
        makeCurrent: true,
        testId: testDetails?.testId,
        setId: selectedSetId,
      })
    );

    const selectedQuestion = questionsData.find((q) => q.qid === qid);
    if (!selectedQuestion) return;

    dispatch(
      fetchExamQuestionRequest({
        qid,
        paperId: selectedQuestion.paper_id,
        testId: testDetails?.testId,
        setId: selectedSetId,
      })
    );
  };

  const onMarkReview = () => {
    const currentQuestion = questionsData[currentQuestionIndex];
    if (!currentQuestion) return;

    dispatch(
      updateQuestionStatus({
        qid: currentQuestion.qid,
        markReview: true,
        testId: testDetails?.testId,
        setId: selectedSetId,
      })
    );
  };

  /* ======================= SUBMIT TEST ======================= */
  const handleSubmitExam = () => {
    const totalTimeTaken =
      typeof paper_duration === "number" && typeof timeLeft === "number"
        ? paper_duration - timeLeft
        : 0;

    dispatch(
      submitExamRequest({
        paperType: testDetails?.paperType,
        paperId,
        plannerId: plannerDetails?.planner_id,
        setId: selectedSetId,
        time: totalTimeTaken,
      })
    );


    if (isPracticeMode) {
      dispatch(resetPracticeStreak());
    }

    setSubmitModalOpen(false);

    if (isPracticeMode) {
      history.push("/practice-summary");
    } else {
      history.push("/analytics");
    }
  };
  const handleExitTest = () => {
    const source = testDetails?.source;

    if (source === "topicwise") {
      history.push("/practice/topic-wise/pyqset");
    }
    else if (source === "yearwise") {
      history.push("/practice/paper-listing?type=Year Wise");
    }
    else {
      history.push("/practice/paper-listing");
    }
  };

  if (loading) {
    return (
      <div className="loading_center_container">
        <ClipLoader size={40} color="#C61C26" />
      </div>
    );
  }

  return (
    <div className="exam-wrapper">
      <Header
        onSubmit={() => setSubmitModalOpen(true)}
        onExitClick={() => setShowExitModal(true)}
      />

      {/* <div className="exam-body"> */}
      {/* <div className="exam-content"> */}
      <div className={"exam-body with-overview"}>
        <div className="exam_content_container">

          {isPracticeMode && (
            <div style={{ margin: "0 0 24px 0", padding: "0 16px" }}>
              <PracticeModeProgressBar
                totalQuestions={questionsData.length}
                streak={practiceStreak}
                questionIndex={currentQuestionIndex}
              />
            </div>
          )}

          <SectionTabs onSelectQuestion={handleSelectQuestion} />

          {/* <QuestionCard questionId={activeQuestionId} /> */}
          {activeQuestionId && (
            <QuestionCard questionId={activeQuestionId} />
          )}

          <Footer
            onSaveNext={handleSaveAndNext}
            onMarkReview={onMarkReview}
          />
        </div>
      </div>
      {/* </div> */}

      {/* ======================= SUBMIT MODAL ======================= */}
      <SubmitModal
        isOpen={isSubmitModalOpen}
        onClose={() => setSubmitModalOpen(false)}
        onSubmit={handleSubmitExam}
        title="Submit Exam?"
        subtitle="Are you sure you want to submit your answers?"
        imageSrc={images.submit_icon}
        totalQuestions={questionsData?.length || 0}
        notAttempted={stats.notVisited + stats.notAnswered}
        attempted={stats.answered}
        markedForReview={stats.marked + stats.answeredMarked}
        cancelButtonProps={{
          title: "Cancel",
          variant: "outlined",
          color: "error",
          onClick: () => setSubmitModalOpen(false),
        }}
        submitButtonProps={{
          title: loading ? "Submitting..." : "Submit",
          variant: "contained",
          color: "error",
          onClick: handleSubmitExam,
        }}
      />
      {/* This is for exit modal */}
      <SubmitModal
        isOpen={showExitModal}
        onClose={() => setShowExitModal(false)}
        title="Exit Test"
        subtitle="Are you sure you want to exit? Your answers are saved and you can resume anytime."
        imageSrc={images.exit_modal_icon}
        totalQuestions={questionsData?.length || 0}
        notAttempted={stats.notVisited + stats.notAnswered}
        attempted={stats.answered}
        markedForReview={stats.marked + stats.answeredMarked}
        cancelButtonProps={{
          title: "Go Back To Test",
          variant: "outlined",
          color: "error",
          onClick: () => setShowExitModal(false),
        }}
        submitButtonProps={{
          title: "Exit Test",
          variant: "contained",
          color: "error",
          onClick: handleExitTest,
        }}
      />
    </div>
  );
};

export default TestScreen;
